import { useGetAvailableExamEventYearsQuery } from '@exam-center/graphql';
import { useNavigate, useParams } from '@exam-center/router';
import { Selection } from '@shared/components';
import { dayjs } from '@shared/utils';
import { createSearchParams } from 'react-router-dom';

import { useExamDistributionListSearchParams } from '../../hooks';
import { getExamEventYearsSelectionOptions } from '../../utils';

const currentYear = dayjs().year();

export default function ExamDistributionYearSelection() {
  const { year } = useParams('/admin/exam-distribution/year/:year');
  const [{ examCenters }] = useExamDistributionListSearchParams();

  const navigate = useNavigate();

  const { data: availableExamEventYearsData } = useGetAvailableExamEventYearsQuery();
  const existingYears =
    availableExamEventYearsData?.ecGetAvailableExamEventICTYears.ictExamYears ?? [];

  const yearOptions = getExamEventYearsSelectionOptions(existingYears, currentYear);

  const handleYearChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    const selectedYear = event.target.value;
    navigate(
      {
        pathname: '/admin/exam-distribution/year/:year',
        search:
          examCenters.length > 0
            ? createSearchParams({
                examCenters: examCenters.join(','),
              }).toString()
            : undefined,
      },
      {
        params: { year: selectedYear },
      },
    );
  };

  return (
    <Selection
      label='Year'
      value={parseInt(year)}
      options={yearOptions}
      onChange={handleYearChange}
      sx={{ maxWidth: '180px' }}
    />
  );
}
